export default {
	toast: 'CreateToast',
	modal: 'CreateModal'
}